export const generateRandomUUID = () => crypto.randomUUID();
